import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { auth, db } from '../firebase';
import { useTheme } from '../components/AppThemes';

import { signOut } from 'firebase/auth';

import {
  doc,
  onSnapshot,
  collection,
  deleteDoc,
  addDoc,
  serverTimestamp
} from 'firebase/firestore';


// ফোন নম্বর ফরমেট ঠিক রাখার হেল্পার ফাংশন
const normalizePhone = (p) => {
  if (!p) return '';
  let d = p.replace(/\D/g, '');
  if (d.startsWith('880')) d = d.substring(3);
  if (d.startsWith('0')) d = d.substring(1);
  return `+880${d}`;
};


const Settings = () => {

const navigate = useNavigate();


const [userData,setUserData] = useState(null);

const { preference, setTheme } = useTheme();

const [reportOpen, setReportOpen] = useState(false);
const [reportText, setReportText] = useState('');
const [reportSending, setReportSending] = useState(false);


// ভিউ কন্ট্রোল করার জন্য স্টেট ('settings' অথবা 'blocklist')
const [view, setView] = useState('settings');

// ব্লকলিস্টে থাকা ইউজারদের স্টেট
const [blockedUsers, setBlockedUsers] = useState([]);




useEffect(()=>{


const userUid =
localStorage.getItem('nexora_user_uid')
||
auth.currentUser?.uid;


if(!userUid){
navigate('/login');
return;
}




const unsub = onSnapshot(
doc(db,'users',userUid),
(snapshot)=>{

if(snapshot.exists()){

setUserData(snapshot.data());

}

}

);



return ()=>unsub();


},[navigate]);



// রিয়েল-টাইম ব্লক লিস্ট লোড করার জন্য useEffect
useEffect(() => {
  if (!userData?.phoneNumber) return;

  const myPhone = normalizePhone(userData.phoneNumber);
  
  // ফোনবুকের কন্টাক্ট ডাটা নিয়ে আসার চেষ্টা
  let localContacts = {};
  try {
    localContacts = JSON.parse(localStorage.getItem('nexora_local_contacts') || '{}');
  } catch (e) {}

  const blockedRef = collection(db, 'block_list', myPhone, 'blocked_users');
  
  const unsubBlocked = onSnapshot(blockedRef, (snapshot) => {
    const list = [];
    snapshot.forEach((docSnap) => {
      const phone = docSnap.id;
      const displayName = localContacts[phone] || phone;
      list.push({ phone, name: displayName });
    });
    setBlockedUsers(list);
  });

  return () => unsubBlocked();
}, [userData?.phoneNumber]);



const handleLogout = async()=>{


try{


await signOut(auth);

localStorage.removeItem(
'nexora_user_uid'
);


navigate('/login');


}catch(error){

console.log(error);

}


};


// ফায়ারস্টোর থেকে আনব্লক করার হ্যান্ডলার
const handleUnblock = async (blockedPhone) => {
  if (!userData?.phoneNumber) return;
  const myPhone = normalizePhone(userData.phoneNumber);

  if (await window.nexoraConfirm(`${blockedPhone} নম্বরটি আনব্লক করতে চান?`)) {
    try {
      await deleteDoc(doc(db, 'block_list', myPhone, 'blocked_users', blockedPhone));
    
    } catch (error) {
      console.error("Unblock failed:", error);
    }
  }
};

const handleReportSubmit = async () => {
  const message = reportText.trim();

  if (!message) {
    window.nexoraAlert('সমস্যাটি লিখুন।');
    return;
  }

  const uid = localStorage.getItem('nexora_user_uid') || auth.currentUser?.uid;

  if (!uid || !userData) {
    window.nexoraAlert('ইউজার তথ্য পাওয়া যায়নি। আবার লগইন করুন।');
    return;
  }

  try {
    setReportSending(true);

    const payload = {
      uid,
      fullName: userData.fullName || '',
      phoneNumber: userData.phoneNumber || '',
      photoURL: userData.photoURL || '',
      problem: message,
      status: 'Pending',
      createdAt: serverTimestamp(),
      reporterName: userData.fullName || 'User',
      reporterUid: uid,
      source: 'settings_report_problem',
    };

    // The Editor page listens to reportProblems for “Report Problems” cards.
    // Keep a second legacy write to reports for any older admin flows.
    await Promise.all([
      addDoc(collection(db, 'reportProblems'), payload),
      addDoc(collection(db, 'reports'), {
        ...payload,
        type: 'problem',
      })
    ]);

    setReportText('');
    setReportOpen(false);
    window.nexoraAlert('আপনার রিপোর্ট সফলভাবে পাঠানো হয়েছে।');
  } catch (error) {
    console.error('Report submission failed:', error);
      window.nexoraAlert('রিপোর্ট পাঠানো যায়নি। আবার চেষ্টা করুন।');
  } finally {
    setReportSending(false);
  }
};



return (

<div style={styles.container}>


<style>{`

*{
box-sizing:border-box;
font-family:-apple-system,BlinkMacSystemFont,
"Segoe UI",Roboto,sans-serif;
}


.settings-card{

width:100%;
max-width:480px;
height:100dvh;
min-height:100vh;
background:#f8fafc;
overflow-y:auto;
overflow-x:hidden;
-webkit-overflow-scrolling:touch;
overscroll-behavior-y:auto;
padding-bottom:20px;
}

html[data-nexora-theme="dark"] .theme-invariant-white{
color:#000000 !important;
filter:none;
}


.setting-row{

display:flex;
align-items:center;
justify-content:space-between;
padding:15px;
background:white;
border-radius:18px;
margin-bottom:10px;
border:1px solid #f1f5f9;
cursor:pointer;

}


.row-left{

display:flex;
align-items:center;
gap:14px;

}


.logout-btn{

width:100%;
padding:15px;
border-radius:18px;
border:1px solid #fecaca;
background:#fef2f2;
color:#ef4444;
font-weight:800;
font-size:14px;

}



.switch{

position:relative;
width:44px;
height:24px;

}



.switch input{

opacity:0;

}



.slider{

position:absolute;
inset:0;
background:#cbd5e1;
border-radius:20px;

}


.slider:before{

content:"";
position:absolute;
height:18px;
width:18px;
background:white;
left:3px;
bottom:3px;
border-radius:50%;
transition:.3s;

}



input:checked + .slider{

background:#2563eb;

}



input:checked + .slider:before{

transform:translateX(20px);

}



.report-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(15, 23, 42, .45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.report-modal {
  width: 100%;
  max-width: 430px;
  background: #fff;
  border-radius: 22px;
  padding: 20px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, .2);
}

.report-modal-title {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.report-modal-subtitle {
  margin-top: 5px;
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
}

.report-textarea {
  width: 100%;
  min-height: 130px;
  margin-top: 16px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  resize: vertical;
  outline: none;
  font: inherit;
  font-size: 14px;
  color: #0f172a;
  background: #f8fafc;
}

.report-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

.report-cancel,
.report-submit {
  flex: 1;
  padding: 12px;
  border-radius: 13px;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}

.report-cancel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #475569;
}

.report-submit {
  background: #2563eb;
  border: 1px solid #2563eb;
  color: #fff;
}

.report-cancel:disabled,
.report-submit:disabled {
  opacity: .6;
  cursor: not-allowed;
}

/* নতুন ব্লক লিস্টের ডিজাইন */
.blocklist-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
}

.block-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: white;
  border-radius: 18px;
  border: 1px solid #f1f5f9;
}

.unblock-btn-row {
  background: #fef2f2;
  color: #ef4444;
  border: 1px solid #fecaca;
  padding: 6px 14px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.empty-blocklist {
  text-align: center;
  color: #94a3b8;
  font-size: 14px;
  padding: 40px 0;
  font-weight: 600;
}


`}</style>





<div className="settings-card">


{view === 'settings' ? (

  /* ১. মেইন সেটিংস ভিউ */
  <>

    <div style={styles.header}>


    <button
    className="theme-invariant-white"
    style={styles.backBtn}
    onClick={()=>navigate('/dashboard')}
    >
    ←
    </button>



    <h2 className="theme-invariant-white" style={styles.headerTitle}>
    Settings
    </h2>


    <div/>

    </div>





    <div style={{padding:"20px"}}>





    <div
    style={styles.profileCard}
    onClick={()=>navigate('/profile')}
    >


    <img

    src={
    userData?.photoURL ||
    userData?.photoUrl ||
    "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150"
    }

    style={styles.profileAvatar}

    onError={(event) => {
      event.currentTarget.src = "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150";
    }}

    />



    <div style={{flex:1}}>


    <div className="theme-invariant-white" style={styles.profileName}>

    {
    userData?.fullName ||
    "Loading..."
    }

    </div>


    <div style={styles.profilePhone}>

    {
    userData?.phoneNumber || ""
    }

    </div>


    </div>



    <button className="theme-invariant-white" style={styles.editBtn}>
    Edit
    </button>


    </div>





    <div style={styles.sectionTitle}>
    ACCOUNT
    </div>


    <div
    className="setting-row"
    onClick={()=>navigate('/contract')}
    >
      <div className="row-left">
        <span style={{fontSize:"22px"}}>📄</span>
        <div>
          <div style={styles.rowTitle}>Contract</div>
          <div style={styles.rowSubtitle}>View contract information</div>
        </div>
      </div>
      <span style={{fontSize:"22px",color:"#94a3b8"}}>›</span>
    </div>


    <div
    className="setting-row"
    onClick={()=>navigate('/change-password')}
    >
      <div className="row-left">
        <span style={{fontSize:"22px"}}>🔐</span>
        <div>
          <div style={styles.rowTitle}>Change Password</div>
          <div style={styles.rowSubtitle}>Update your account password</div>
        </div>
      </div>
      <span style={{fontSize:"22px",color:"#94a3b8"}}>›</span>
    </div>

    <div className="setting-row" style={{ cursor: 'default' }}>
      <div className="row-left">
        <span style={{fontSize:"22px"}}>🎨</span>
        <div>
          <div style={styles.rowTitle}>Themes</div>
          <div style={styles.rowSubtitle}>Choose the app appearance</div>
        </div>
      </div>
      <select
        aria-label="Themes"
        value={preference}
        onChange={event => setTheme(event.target.value)}
        style={styles.themeSelect}
      >
        <option value="system">System default</option>
        <option value="light">Light-Mode</option>
        <option value="dark">Dark-Mode</option>
      </select>
    </div>


  








          {/* BLOCK LIST BUTTON */}

          <div style={styles.sectionTitle}>
            SECURITY
          </div>



          <div

          className="setting-row"

          onClick={()=>setView('blocklist')}

          >


            <div className="row-left">


              <span style={{fontSize:"22px"}}>
                🚫
              </span>


              <div>

                <div style={styles.rowTitle}>
                  Block List
                </div>


                <div style={styles.rowSubtitle}>
                  Manage blocked users
                </div>


              </div>


            </div>



            <span style={{
              fontSize:"22px",
              color:"#94a3b8"
            }}>
              ›
            </span>


          </div>









          {userData?.role === 'Editor' && (
            <>
              <div style={styles.sectionTitle}>
                EDITOR
              </div>

              <div
                className="setting-row"
                onClick={()=>navigate('/editor')}
              >
                <div className="row-left">
                  <span style={{fontSize:"22px"}}>✏️</span>
                  <div>
                    <div style={styles.rowTitle}>Edit Page</div>
                    <div style={styles.rowSubtitle}>Manage users, reports and Nexora Officials</div>
                  </div>
                </div>
                <span style={{fontSize:"22px",color:"#94a3b8"}}>›</span>
              </div>
            </>
          )}

          {userData?.role !== 'Editor' && (
            <>
          <div style={styles.sectionTitle}>
            SUPPORT
          </div>

          <div
            className="setting-row"
            onClick={()=>setReportOpen(true)}
          >
            <div className="row-left">
              <span style={{fontSize:"22px"}}>⚠️</span>
              <div>
                <div style={styles.rowTitle}>Report a Problem</div>
                <div style={styles.rowSubtitle}>Tell us about a problem or issue</div>
              </div>
            </div>
            <span style={{fontSize:"22px",color:"#94a3b8"}}>›</span>
          </div>

          {reportOpen && (
            <div className="report-overlay" onClick={()=>setReportOpen(false)}>
              <div className="report-modal" onClick={(e)=>e.stopPropagation()}>
                <div className="report-modal-title">Report a Problem</div>
                <div className="report-modal-subtitle">Tell us what went wrong and we will review it.</div>

                <textarea
                  value={reportText}
                  onChange={(e)=>setReportText(e.target.value)}
                  placeholder="Describe your problem..."
                  className="report-textarea"
                  rows={6}
                  maxLength={2000}
                />

                <div className="report-actions">
                  <button
                    type="button"
                    className="report-cancel"
                    onClick={()=>setReportOpen(false)}
                    disabled={reportSending}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="report-submit"
                    onClick={handleReportSubmit}
                    disabled={reportSending}
                  >
                    {reportSending ? 'Sending...' : 'Send Report'}
                  </button>
                </div>
              </div>
            </div>
          )}
            </>
          )}


          <div style={styles.sectionTitle}>
            ABOUT NEXORA
          </div>





          <div className="setting-row">


            <div className="row-left">


              <span style={{fontSize:"20px"}}>
                📱
              </span>


              <div>


                <div style={styles.rowTitle}>
                  Nexora Version
                </div>


                <div style={styles.rowSubtitle}>
                  v1.0.0 Production
                </div>


              </div>


            </div>


          </div>







          <button

          onClick={handleLogout}

          className="logout-btn"

          >

          Log Out of Nexora

          </button>






          </div>

  </>

) : (

  /* ২. ব্লক লিস্ট ভিউ */
  <>

    <div style={styles.header}>


    <button
    style={styles.backBtn}
    onClick={()=>setView('settings')}
    >
    ←
    </button>



    <h2 style={styles.headerTitle}>
    Block List
    </h2>


    <div/>

    </div>



    <div className="blocklist-container">

      {blockedUsers.length === 0 ? (

        <div className="empty-blocklist">
          কোনো নম্বর ব্লক লিস্টে নেই।
        </div>

      ) : (

        blockedUsers.map((user) => (

          <div className="block-row" key={user.phone}>

            <div>

              <div style={{ fontWeight: '700', fontSize: '14px', color: '#0f172a' }}>
                {user.name}
              </div>

              {user.name !== user.phone && (
                <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px' }}>
                  {user.phone}
                </div>
              )}

            </div>


            <button 
            className="unblock-btn-row" 
            onClick={() => handleUnblock(user.phone)}
            >
              Unblock
            </button>

          </div>

        ))

      )}

    </div>

  </>

)}


    </div>


  </div>


);


};









const styles={


container:{

minHeight:"100vh",

background:"#fafafa",

display:"flex",

justifyContent:"center",

width:"100%"

},




header:{

height:"60px",

background:"#fff",

display:"flex",

alignItems:"center",

justifyContent:"space-between",

padding:"0 16px",

position:"relative",

borderBottom:"1px solid #eee"

},




backBtn:{

background:"none",

border:"none",

fontSize:"26px",

cursor:"pointer"

},




headerTitle:{

fontSize:"18px",

fontWeight:"800",

margin:0

},




profileCard:{

display:"flex",

alignItems:"center",

gap:"14px",

background:"#fff",

padding:"16px",

borderRadius:"20px",

marginBottom:"20px"

},




profileAvatar:{

width:"56px",

height:"56px",

borderRadius:"50%",

objectFit:"cover"

},




profileName:{

fontSize:"16px",

fontWeight:"800"

},




profilePhone:{

fontSize:"12px",

color:"#64748b"

},




editBtn:{

padding:"7px 14px",

borderRadius:"12px",

background:"#fff",

border:"1px solid #ddd"

},




sectionTitle:{

fontSize:"11px",

fontWeight:"800",

color:"#94a3b8",

margin:"18px 5px 8px"

},




rowTitle:{

fontSize:"15px",

fontWeight:"700"

},




rowSubtitle:{

fontSize:"12px",

color:"#64748b"

},


themeSelect:{

padding:"8px 10px",

border:"1px solid #e2e8f0",

borderRadius:"10px",

background:"#f8fafc",

color:"#0f172a",

fontSize:"12px",

fontWeight:"700",

outline:"none",

maxWidth:"150px"

}



};




export default Settings;